<app-header></app-header>

<div>
    <router-outlet></router-outlet>
</div>

<footer class="footer">
    <app-footer></app-footer>
</footer>